import { computed, Injectable, signal } from '@angular/core';
import { Toast } from '@mwe/models';
import ShortUniqueId from 'short-unique-id';

@Injectable({ providedIn: 'root' })
export class ToastService {
  toastQueue = signal<Toast[]>([]);
  visibleToasts = computed<Toast[]>(() => {
    const arr = this.toastQueue();
    return arr.slice(0, 3);
  });

  publishNewToast(newToast: Toast) {
    newToast.uuid = new ShortUniqueId({ dictionary: 'alpha' }).rnd(8);
    const toastQueue = [...this.toastQueue()];
    toastQueue.push(newToast);
    this.toastQueue.set(toastQueue);
  }

  removeToast(uuid: string) {
    this.toastQueue.update(toasts => {
      const filteredItems = toasts.filter(value => value.uuid !== uuid);
      return filteredItems;
    });
  }
}
